<template>
  <div class="c-tags-container">
    <div class="c-tags-chip" :class="{'c-tags-editing': editingIndex === index}" v-for="(tag, index) in tags" :key="index">
      <div class="c-tags-chip-text" @click="selectToEdit(index)">
        {{ tag }}
      </div>
      <input type="text" :ref="'c-tags-editing-input' + index" class="c-tags-editing-input" v-model="editingValue" @keydown="handleEditKeydown" @input="updateTag" @blur="afterEdit" v-show="editingIndex === index">
      <svg viewBox="0 0 24 24" focusable="false" class="c-tags-x" @click="deleteTag(index)">
          <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" fill="#8e8e8e"></path>
      </svg>
    </div>
    <input type="text" class="c-tags-adding-input" v-model="currentValue" @keydown="handleAddKeydown" @blur="() => {this.addTag()}">
  </div>
</template>

<script>

export default {
  name: "CustomTags",
  components: {},
  props: {
    initTags: {
      type: Array,
      default: null
    },
    setTags: {
      type: Function,
      required: false
    },
    lang: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      tags: [],
      currentValue: '',
      editingIndex: null,
      editingValue: ''
    }
  },
  mounted() {
    if (this.initTags) {
      this.tags = this.initTags;
    }
  },
  watch: {
    initTags (nextProps, props) {
      if (JSON.stringify(nextProps) !== JSON.stringify(props)) {
        this.tags = this.initTags;
      }
    }
  },
  methods: {
    updateTag(e) {
      let v = e.target.value;
      if (v) {
        v = v.replace(/"/g, "");
        if (v) {
          if (v !== this.tags[this.editingIndex]) {
            this.tags.splice(this.editingIndex, 1, v);
            this.setTags(this.tags, this.lang);
          }
        } else {
          this.deleteTag(this.editingIndex);
        }
      } else {
        if (this.editingIndex || this.editingIndex === 0) {
          this.deleteTag(this.editingIndex);
        }
      }
    },
    handleEditKeydown(e) {
      if (e && e.keyCode === 13) {
        this.afterEdit();
      }
    },
    afterEdit() {
      this.editingValue = '';
      this.editingIndex = null;
    },
    selectToEdit(tagIndex) {
      this.editingValue = this.tags[tagIndex];
      this.editingIndex = tagIndex;
      this.$nextTick(() => {
        this.$refs[`c-tags-editing-input${tagIndex}`][0].focus();
      });
    },
    handleAddKeydown(e) {
      if (e && e.keyCode === 13) {
        this.addTag(e.target.value)
      }
    },
    addTag(value) {
      let v = value ? value : this.currentValue;
      if (v) {
        v = v.replace(/"/g, "");
        if (v && this.tags.indexOf(v) === -1) {
          this.tags.push(v);
          this.setTags(this.tags, this.lang);
        }
        this.currentValue = '';
      }
    },
    deleteTag(tagIndex) {
      this.tags.splice(tagIndex, 1);
      this.editingValue = '';
      this.editingIndex = null;
      this.setTags(this.tags, this.lang);
    }
  },
}

</script>

<style scoped lang="scss">
  .c-tags-container {
    background: none;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .c-tags-adding-input {
    display: flex;
    flex-grow: 1;
    background: transparent;
    border: none;
    font-size: 14px;
    font-weight: 400;
    font-family: unset;
    margin: 2px 5px;
    height: 26px;
    min-width: 40px;
  }
  .c-tags-adding-input:focus {
    max-width: 250px;
  }
  .c-tags-editing-input {
    display: flex;
    flex-grow: 1;
    background: transparent;
    border: none;
    font-size: 14px;
    font-weight: 400;
    font-family: unset;
    height: 22px;
    min-width: 40px;
    max-width: 300px;
    position: absolute;
    left: 0;
    top: 0px;
    width: 100%;
    padding: 0 25px 0 4px;
  }
  .c-tags-x {
    width: 20px;
    height: 20px;
    min-width: 20px;
    cursor: pointer;
    margin-left: 5px;
    z-index: 1000;
  }
  .c-tags-x:hover path {
    fill: #5e5e5e;
  }
  .c-tags-chip {
    position: relative;
    display: inline-flex;
    height: 26px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin: 2px;
    max-width: 300px;
    background-color: #f0f0f0;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    padding: 0 0.25em;
  }
  .c-tags-chip.c-tags-editing {
    border: 1px solid #7367f0;
    .c-tags-chip-text {
      opacity: 0;
    }
  }
  .c-tags-chip:not(.c-tags-editing):hover {
    background-color: rgba(221,221,221,0.8);
  }
  .c-tags-chip-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #2c2c2c;
    font-size: 14px;
    font-weight: 400;
  }
</style>
